import { Injectable, signal } from "@angular/core"
import { RegionProperties } from "../components/map/map.type"

@Injectable({
  providedIn: "root",
})
export class GeoJsonLoaderService {
  private cache = new Map<string, any>()
  loadedData = signal<Map<string, any>>(new Map())

  async loadGeoJson(url: string): Promise<any> {
    if (this.cache.has(url)) {
      return this.cache.get(url)
    }

    try {
      // Use fetch instead of HttpClient to bypass interceptors
      const response = await fetch(url)
      if (!response.ok) {
        throw new Error(`Failed to fetch ${url}: ${response.statusText}`)
      }

      const data = await response.json()
      this.cache.set(url, data)

      // Update the signal for reactive components
      const updatedMap = new Map(this.loadedData())
      updatedMap.set(url, data)
      this.loadedData.set(updatedMap)

/*
      if (this.loadedData().size === 23) {
        let regionPropertiesArray: RegionProperties[] = [] as RegionProperties[]
        this.loadedData().forEach((value, key) => {
          value.features.forEach((feature: any) => {
            regionPropertiesArray.push(feature.properties as RegionProperties)
          })
        })

        console.log(regionPropertiesArray)

        const array = [
          // "city",
          "grade",
          "security_grade",
          // "area_number",
          // "description_of_terrain",
          // "favorable_influences",
          // "detrimental_influences",
          "occupation_or_type",
          // "estimated_annual_family_income",
          // "foreign_born_nationality",
          // "foreign_born_percent",
          // "negro_yes_or_no",
          // "negro_percent",
          // "infiltration_of",
          // "occupancy",
          // "dwelling_units",
          // "home_ownership",
          // "availability_of_mortgage_funds_home_purchase",
          // "availability_of_mortgage_funds_home_building",
          // "trend_of_desirability",
          // "clarifying_remarks",
          // "information_obtained_from",
          // "information_obtained_month_and_day",
          // "information_obtained_193x",
        ]

        const results: [number, string][] = []

        array.forEach(key => {
          let trueCount = 0
          let falseCount = 0

          regionPropertiesArray.forEach(regionProperties => {
            if (regionProperties[key as keyof RegionProperties]) {
              trueCount++
            } else {
              falseCount++
            }
          })

          const securityGradeArray = regionPropertiesArray.filter(regionProperties => regionProperties.security_grade)
          const gradeArray = regionPropertiesArray.filter(regionProperties => regionProperties.grade)
          const gradeFromSecurityGradeArray = securityGradeArray.filter(regionProperties => regionProperties.grade)
          // const occupationOrTypeArrayFromSecurityGradeArray = securityGradeArray.filter(regionProperties => regionProperties.occupation_or_type)
          // const occupationOrTypeArray = regionPropertiesArray.filter(regionProperties => regionProperties.occupation_or_type)

          console.log("securityGrade", securityGradeArray.length)
          console.log("grade", gradeArray.length)
          console.log( "grade in securityGrade", gradeFromSecurityGradeArray.length)


          results.push([trueCount, key])

          // console.log(trueCount, key)

        })

        console.log(regionPropertiesArray.length)

        console.log(
          results
            .map(([trueCount, key]) => `${trueCount}: ${key}`)
            .join("\n")
        )
        // console.table(results)

      }
*/

      return data
    } catch (error) {
      console.error(`Error loading GeoJSON from ${url}:`, error)
      throw error
    }
  }

  getLoadedData() {
    return this.loadedData.asReadonly()
  }
}
